import { call, all, put, takeEvery } from 'redux-saga/effects';
import { normalizeTakeAssessmentPayload } from '../../../utils/apiPayload';
import {
  getExternalUserSuccessAction,
  getExternalUserFailureAction,
  setExternalUserSuccessAction,
  setExternalUserFailureAction,
  getConsentSuccessAction,
  getConsentFailureAction,
  setConsentSuccessAction,
  setConsentFailureAction,
  setUserImageSuccessAction,
  setUserImageFailureAction,
  getUserEvaluationSuccessAction,
  getUserAssessmentSuccessAction,
  getUserAssessmentFailureAction,
  getUserEvaluationFailureAction,
  setUserAssessmentSuccessAction,
  setUserAssessmentFailureAction,
  setQuestionSuccessAction,
  setQuestionFailureAction,
  // getAttendedQuestionCountSuccessAction,
  // getAttendedQuestionCountFailureAction,
  saveInternalQuestionSuccessAction,
  saveInternalQuestionFailureAction,
  saveExternalUserDeviceDetailsSuccessAction,
  saveExternalUserDeviceDetailsFailureAction,
  saveImagesFromSkillInsightAppSuccessAction,
  saveImagesFromSkillInsightAppFailureAction,
  setExternalImageStoreSuccessAction,
  setExternalImageStoreFailureAction,
  getExternalUserEncryptEmailSuccessAction, getExternalUserEncryptEmailFailureAction,
  saveExternalQuestionSuccessAction,
  saveExternalQuestionFailureAction,
  saveExternalAssessmentResponseSuccessAction,
  saveExternalAssessmentResponseFailureAction,
  saveInternalAssessmentResponseSuccessAction,
  saveInternalAssessmentResponseFailureAction,
  sendMailForHRSuccessAction,
  sendMailForHRFailureAction
} from '../../features/externalusers/externaluserSlice';
import URLs from '../../../constants/urls';
import {
  SET_EXTERNAL_USERS,
  GET_EXTERNAL_USERS,
  GET_CONSENT,
  SET_CONSENT,
  SET_IMAGE,
  GET_EVALUATION,
  GET_ASSESSMENT,
  SET_ASSESSMENT,
  SET_QUESTION,
  // GET_ATTENDED_QUESTION_COUNT,
  SAVE_INTERNAL_QUESTION,
  SAVE_EXTERNAL_USER_DEVICE_DETAILS,
  SAVE_IMAGES_FROM_SKILL_INSIGHT_APP,
  SET_EXTERNAL_IMAGE_STORE,
  GET_EXTERNAL_USER_ENCRYPTED_EMAIL,
  SAVE_EXTERNAL_QUESTION,
  SAVE_ASSESSMENT_RESPONSE_EXTERNAL,
  SAVE_ASSESSMENT_RESPONSE_INTERNAL,
  SEND_MAIL_FOR_HR
} from '../../actions/ExternalUser/actionExternalUserTypes';
import { apiPython as api } from '../../../service/api';
import { getSessionStorage } from '../../../utils/helpers';

export function* getConsentSaga({ payload: data }) {
  try {
    const response = yield api.get(`${URLs.GET_MASTER_CONSENT_USER}`);
    if (response.data.data[0].mstConsentId) {
      const mstConsentId = response.data.data[0].mstConsentId;
      const responseData = yield api.get(`${URLs.GET_CONSENT_DETAILS_ID}?mstConsentId=${mstConsentId}`);
      yield put(getConsentSuccessAction(responseData.data.data));
    }
  } catch (error) {
    yield put(getConsentFailureAction(error));
  }
}

export function* getEvaluationSaga({ payload: data }) {
  try {
    const responseData = yield api.get(`${URLs.GET_EVALUTION_USER}?externalUserEmail=${data['externalUserEmail']}`);
    yield put(getUserEvaluationSuccessAction(responseData.data.data));
  } catch (error) {
    yield put(getUserEvaluationFailureAction(error));
  }
}

export function* getExternalUserSaga({ payload: data }) {
  console.log(data)
  try {
    const response = yield api.get(
      `${URLs.GET_EXTERNAL_USER}?encryptedEmailId=${data['encryptedEmailId']}`
    );
    yield put(getExternalUserSuccessAction(response.data.data));
  } catch (error) {
    yield put(getExternalUserFailureAction(error));
  }
}

export function* setExternalUserSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.SET_EXTERNAL_USER, body);
    if (response.data){
      yield put(setExternalUserSuccessAction(response.data));
    }
  } catch (error) {
    yield put(
      setExternalUserFailureAction(
        error?.response?.data?.message ? error?.response?.data?.message : 'Something went wrong. Please contact administrator!'
      )
    );
  }
}

export function* setConsentSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.SET_CONSENT_DETAILS, body);
    yield put(setConsentSuccessAction(response.data));
  } catch (error) {
    yield put(
      setConsentFailureAction(
        error?.response?.data?.message ? error?.response?.data?.message : 'Something went wrong. Please contact administrator!'
      )
    );
  }
}

export function* setImageSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.SET_USER_IMAGE, body);
    yield put(setUserImageSuccessAction(response.data));
  } catch (error) {
    yield put(
      setUserImageFailureAction(
        error?.response?.data?.message ? error?.response?.data?.message : 'Something went wrong. Please contact administrator!'
      )
    );
  }
}

export function* getQuestionSaga({ payload: data }) {
  try {
    const userType = getSessionStorage('USER_TYPE');
    
    console.log('User Type:', userType);
    console.log('Payload received:', data);

    if (userType === 'Internal') {
      const params = new URLSearchParams();

      if (data?.id) params.append('id', data.id);
      // map correctly
      params.append('isAssessor', true); // or false based on your logic
      if (data?.samID) params.append('SAMId', data.samID);
      if (data?.SkillId) params.append('SkillId', data.SkillId); // optional
      if (data?.loggedUserID) params.append('LoginSamID', data.loggedUserID);

      const url = `${URLs.GET_SELF_ASSESSMENT_SCREEN}?${params.toString()}`;
      console.log('Final Internal URL:', url);

      const response = yield api.post(URLs.TAKE_ASSESSMENT, data);
      yield put(getUserAssessmentSuccessAction(normalizeTakeAssessmentPayload(response.data.data)));
    } else {
      // External User Logic

      const response = data.type
        ? yield api.post(URLs.TAKE_ASSESSMENT, data)
        : yield api.get(
            `${URLs.GET_EVALUTION_QUESTION}?externalUserEmail=${data['externalUserEmail']}&id=${data['id']}&cycleId=${data['cycleId']}`
          );
      yield put(getUserAssessmentSuccessAction(normalizeTakeAssessmentPayload(response.data.data)));
    } 
  } catch (error) {
      yield put(getUserAssessmentFailureAction(error));
    }
}

// For saving Assessment Response for external user
// export function* setQuestionSaga({ payload: body }) {
//   try {
//     const response = yield api.post(URLs.SAVE_EVALUTION_QUESTION, body);
//     yield put(setUserAssessmentSuccessAction(response.data));
//   } catch (error) {
//     yield put(
//       setUserAssessmentFailureAction(
//         error?.response?.data?.message ? error?.response?.data?.message : 'Something went wrong. Please contact administrator!'
//       )
//     );
//   }
// }

export function* saveExternalResponseQuestionSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.SAVE_ASSESSMENT_RESPONSE_EXTERNAL, body);
    yield put(saveExternalAssessmentResponseSuccessAction(response.data));
  } catch (error) {
    yield put(
      saveExternalAssessmentResponseFailureAction(
        error?.response?.data?.message ? error?.response?.data?.message : 'Something went wrong. Please contact administrator!'
      )
    );
  }
}

// For saving Assessment Response for internal user
export function* saveInternalResponseQuestionSaga({ payload: body }) {
  let navigate;
  if (body.navigate) {
    navigate = body.navigate;
    delete body.navigate;
  }
  try {
    const response = yield api.post(URLs.SAVE_ASSESSMENT_RESPONSE_INTERNAL, body);
    yield put(saveInternalAssessmentResponseSuccessAction({ data: response.data, navigate }));
  } catch (error) {
    yield put(
      saveInternalAssessmentResponseFailureAction(
        error?.response?.data?.message ? error?.response?.data?.message : 'Something went wrong. Please contact administrator!'
      )
    );
  }
}

// For saving Assessment Response for internal user
// export function* saveQuestionSaga({ payload: body }) {
//   let data = null;
//   let navigate;
//   if (body.isEvaluation) data = delete body.isEvaluation;
//   if (body.navigate) {
//     navigate = body.navigate;
//     delete body.navigate;
//   }

//   try {
//     const response = data ? yield api.post(URLs.SAVE_ASSESSMENT_RESPONSE_INTERNAL, body) : yield api.post(URLs.SET_QUESTION, body);
//     yield put(setQuestionSuccessAction({ data: response.data, navigate }));
//   } catch (error) {
//     yield put(
//       setQuestionFailureAction(
//         error?.response?.data?.message ? error?.response?.data?.message : 'Something went wrong. Please contact administrator!'
//       )
//     );
//   }
// }

// export function* saveExternalResponseQuestionSaga({ payload: body }) {
//   let data = null;
//   let navigate;
//   if (body.isEvaluation) data = delete body.isEvaluation;
//   if (body.navigate) {
//     navigate = body.navigate;
//     delete body.navigate;
//   }

//   try {
//     const response = data ? yield api.post(URLs.SAVE_ASSESSMENT_RESPONSE_EXTERNAL, body) : yield api.post(URLs.SET_QUESTION, body);
//     yield put(saveExternalAssessmentResponseSuccessAction({ data: response.data, navigate }));
//   } catch (error) {
//     yield put(
//       saveExternalAssessmentResponseFailureAction(
//         error?.response?.data?.message ? error?.response?.data?.message : 'Something went wrong. Please contact administrator!'
//       )
//     );
//   }
// }

// export function* getAttendedQuestionCountSaga({ payload }) {
//   try {
//     const response = yield api.get(
//       `${URLs.GET_ATTENDED_QUESTION_COUNT}?assessmentId=${payload.assessmentId}&cycleId=${payload.cycleId}&loggedUserID=${getSessionStorage(
//         'USER_ID'
//       )}`
//     );
//     yield put(getAttendedQuestionCountSuccessAction(response.data.data));
//   } catch (error) {
//     yield put(getAttendedQuestionCountFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Failed to fetch'));
//   }
// }

export function* saveInternalQuestionSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.SAVE_INTERNAL_QUESTION, body);
    yield put(saveInternalQuestionSuccessAction(response.data.data));
  } catch (error) {
    yield put(saveInternalQuestionFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Failed to save'));
  }
}

export function* saveExternalQuestionSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.SAVE_EXTERNAL_QUESTION, body);
    yield put(saveExternalQuestionSuccessAction(response.data.data));
  } catch (error) {
    yield put(saveExternalQuestionFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Failed to save'));
  }
}

export function* saveExternalUserDeviceDetail({ payload: body }) {
  try {
      const response = yield api.post(URLs.SAVE_EXTERNAL_USER_DEVICE_DETAILS, body);
      yield put(saveExternalUserDeviceDetailsSuccessAction(response.data.data));
  } catch (error) {
    yield put(saveExternalUserDeviceDetailsFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Failed to save'));
  }
}

export function* saveImagesFromSkillInsightApp({ payload: body }) {
  try {
    const response = yield api.post(URLs.SAVE_IMAGES_FROM_SKILL_INSIGHT_APP, body);
    yield put(saveImagesFromSkillInsightAppSuccessAction(response.data.data));
  } catch (error) {
    yield put(saveImagesFromSkillInsightAppFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Failed to save'));
  }
}

export function* setExternalImageStore({ payload: body }) {
  try {
    const response = yield api.post(URLs.SET_EXTERNAL_IMAGE_STORE, body);
    yield put(setExternalImageStoreSuccessAction(response.data.data));
  } catch (error) {
    yield put(setExternalImageStoreFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Failed to save'));
  }
}

export function* sendMailForHRSaga({ payload: body }) {
  console.log('sendMailForHRSaga: payload: ', body);
  try {
    const response = yield api.post(URLs.SEND_MAIL_FOR_HR, body);
    yield put(sendMailForHRSuccessAction(response.data));
  } catch (error) {
    yield put(
      sendMailForHRFailureAction(
        error?.response?.data?.message ? error?.response?.data?.message : 'Failed to send mail to HR'
      )
    );
  }
}

export function* getExternalUserEncryptedEmail({ payload }) {
  try {
    const response = yield api.get(`${URLs.GET_EXTERNAL_USER_ENCRYPTED_EMAIL}?strValue=${payload.strValue}`);
    yield put(getExternalUserEncryptEmailSuccessAction(response.data));
  } catch (error) {
    yield put(getExternalUserEncryptEmailFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Failed to get'));
  }
}

export function* watchExternalUser() {
  yield takeEvery(GET_CONSENT, getConsentSaga);
  yield takeEvery(SET_CONSENT, setConsentSaga);
  yield takeEvery(GET_EXTERNAL_USERS, getExternalUserSaga);
  yield takeEvery(SET_EXTERNAL_USERS, setExternalUserSaga);
  yield takeEvery(SET_IMAGE, setImageSaga);
  yield takeEvery(GET_EVALUATION, getEvaluationSaga);
  yield takeEvery(GET_ASSESSMENT, getQuestionSaga);
  
  // For saving Assessment Response for internal user
  yield takeEvery(SAVE_ASSESSMENT_RESPONSE_INTERNAL, saveInternalResponseQuestionSaga);
  // yield takeEvery(SET_QUESTION, saveQuestionSaga);

  // For saving Assessment Response for external user
  yield takeEvery(SAVE_ASSESSMENT_RESPONSE_EXTERNAL, saveExternalResponseQuestionSaga);
  // yield takeEvery(SET_ASSESSMENT, setQuestionSaga);

  // yield takeEvery(GET_ATTENDED_QUESTION_COUNT, getAttendedQuestionCountSaga);

  // For saving internal user question
  yield takeEvery(SAVE_INTERNAL_QUESTION, saveInternalQuestionSaga);
  // For saving external user question
  yield takeEvery(SAVE_EXTERNAL_QUESTION, saveExternalQuestionSaga);

  yield takeEvery(SAVE_EXTERNAL_USER_DEVICE_DETAILS, saveExternalUserDeviceDetail);
  yield takeEvery(SAVE_IMAGES_FROM_SKILL_INSIGHT_APP, saveImagesFromSkillInsightApp);
  yield takeEvery(SET_EXTERNAL_IMAGE_STORE, setExternalImageStore);
  yield takeEvery(GET_EXTERNAL_USER_ENCRYPTED_EMAIL, getExternalUserEncryptedEmail);
  yield takeEvery(SEND_MAIL_FOR_HR, sendMailForHRSaga);
}

export default function* externalUserSaga() {
  yield all([watchExternalUser()]);
}
